import React, { useState } from 'react'
import { withRouter } from 'react-router-dom'
import * as DelegationActions from '../../../redux/actions/delegations'
import { Label, Button, Container, Col, Row, Alert } from 'reactstrap'
import { I18n } from 'react-redux-i18n'
import { Formik, Form, Field, ErrorMessage } from 'formik'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import SidePopup from '../../SidePopup'
import DelegationValidator from './DelegationValidator'

const DelegationNew = (props) => {
  const delegation = { name: '', city: '', province: '', country: '', brand: '' }
  const [errors, setErrors] = useState({})

  const handleSubmit = (values, { setSubmitting }) => {
    props
      .addNewDelegation({ ...values, company: props.company._id })
      .then(() => hideModal())
      .catch((err) => setErrors(typeof err === 'object' ? err : { error: 'server-error' }))
      .finally(() => setSubmitting(false))
  }

  const hideModal = (e) => {
    if (e) e.preventDefault()
    props.history.goBack()
  }

  const { brands } = props

  return (
    <SidePopup onHide={hideModal}>
      <Formik initialValues={Object.assign({}, delegation)} validate={DelegationValidator} onSubmit={handleSubmit}>
        {({ isSubmitting }) => (
          <Form>
            <Container className='px-0 pt-3'>
              <Row>
                <Col xs={12}>
                  <div className='section-title'>{I18n.t('delegation.new')}</div>
                </Col>
              </Row>
              <Row className='no-gutters'>
                <Col xs={12}>
                  <Label for='delegation.name' className='required'>
                    {I18n.t('delegation.name')}
                  </Label>
                  <Field id='delegation.name' type='text' name='name' className='form-control' />
                  <ErrorMessage name='name' component='small' className='text-danger' />
                </Col>
              </Row>
              <Row className='no-gutters'>
                <Col xs={12}>
                  <Label for='delegation.city'>{I18n.t('delegation.city')}</Label>
                  <Field id='delegation.city' type='text' name='city' className='form-control' />
                  <ErrorMessage name='city' component='small' className='text-danger' />
                </Col>
              </Row>
              <Row className='no-gutters'>
                <Col xs={12}>
                  <Label for='delegation.province'>{I18n.t('delegation.province')}</Label>
                  <Field id='delegation.province' type='text' name='province' className='form-control' />
                  <ErrorMessage name='province' component='small' className='text-danger' />
                </Col>
              </Row>
              <Row className='no-gutters'>
                <Col xs={12}>
                  <Label for='delegation.country'>{I18n.t('delegation.country')}</Label>
                  <Field id='delegation.country' type='text' name='country' className='form-control' />
                  <ErrorMessage name='country' component='small' className='text-danger' />
                </Col>
              </Row>
              <Row className='no-gutters'>
                <Col xs={12}>
                  <Label for='delegation.brand' className='required'>
                    {I18n.t('delegation.brand')}
                  </Label>
                  <Field component='select' id='delegation.country' type='text' name='brand' className='form-control'>
                    <option value=''>{I18n.t('delegation.selectBrand')}</option>
                    {Object.values(brands).map((b) => (
                      <option key={b._id} value={b._id}>
                        {b.name}
                      </option>
                    ))}
                  </Field>
                  <ErrorMessage name='brand' component='small' className='text-danger' />
                </Col>
              </Row>

              {Object.keys(errors).length > 0 && (
                <Row className='mt-3'>
                  {Object.keys(errors).map((e, i) => (
                    <Col key={i} xs={12}>
                      <Alert color='danger'>{I18n.t(`dashboard_errors_${errors[e]}`)}</Alert>
                    </Col>
                  ))}
                </Row>
              )}

              <Row className='no-gutters mt-3'>
                <Col>
                  <Button disabled={isSubmitting} onClick={hideModal} color='default'>
                    {I18n.t('dashboard_cancel')}
                  </Button>
                </Col>
                <Col className='text-right'>
                  <Button type='submit' disabled={isSubmitting} color='primary'>
                    {I18n.t('dashboard_save')}
                  </Button>
                </Col>
              </Row>
            </Container>
          </Form>
        )}
      </Formik>
    </SidePopup>
  )
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(Object.assign({}, DelegationActions), dispatch)
}

function mapStateToProps(state) {
  return { brands: state.brands, company: state.companies }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(DelegationNew))
